// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"603":"edit_prose","616":"edit_editorjs","886":"editing-edit-tinymce","964":"editing-edit-prose","973":"styles-tinymce_custom_style-css"}[chunkId] || chunkId) + ".css";
};